import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  signal,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { finalize, firstValueFrom } from 'rxjs';
import { DialogPromptAiComponent } from 'src/app/components/dialog-prompt-ai/dialog-prompt-ai.component';
import { Padre } from 'src/app/components/select-custom/select-custom.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import {
  AzioneBP,
  AzioneEBuonaPraticaService,
} from 'src/app/services/azione-e-buona-pratica/azione-e-buona-pratica.service';
import { BilancioService } from 'src/app/services/bilancio/bilancio.service';
import { PianoService } from 'src/app/services/piano/piano.service';
import { PolicyService } from 'src/app/services/policy/policy.service';
import { Settore, SettoriService } from 'src/app/services/settori/settori.service';
import { SintesiService } from 'src/app/services/sintesi/sintesi.service';
import {
  StandardRendicontazioneService,
  STDR,
} from 'src/app/services/standard-rendicontazione/standard-rendicontazione.service';
import { TipoElemento, UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-crea-cfg-azione-e-buona-pratica',
  templateUrl: './dialog-crea-cfg-azione-e-buona-pratica.component.html',
  styleUrls: ['./dialog-crea-cfg-azione-e-buona-pratica.component.scss'],
  standalone: false,
})
export class DialogCreaCfgAzioneEBuonaPraticaComponent implements AfterViewInit {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public selectedSettori: string[] = [];
  public arrayStdr: {
    chiave: string;
    descrizione: string;
  }[] = [];
  public arraySettori: Settore[] = [];

  private objStdrOriginale: STDR[] = [];
  public mostraNote: boolean = false;
  //Signal per controllare la chiususra della dialog
  closeDialog = signal<boolean>(true);

  /* Form Controls */
  public formAzioneBP = new FormGroup({
    id: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),

    titolo: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, UtilityService.blankValidator],
    }),

    descrizione: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, UtilityService.blankValidator],
    }),

    settori: new FormControl<Settore[]>([], {
      nonNullable: true,
    }),

    note: new FormControl<string>('', {
      nonNullable: true,
      validators: [],
    }),
    tag: new FormControl<string>('', {
      nonNullable: true,
      validators: [],
    }),
    creatoDaContesto: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [],
    }),
    selected: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [],
    }),
    compilato: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [],
    }),
    figura: new FormControl<any>(undefined, {
      nonNullable: true,
      validators: [],
    }),
  });

  public stdr = new FormControl<Padre[]>([]);
  public compliance = new FormControl<Padre[]>([]);

  constructor(
    public dialogRef: MatDialogRef<DialogCreaCfgAzioneEBuonaPraticaComponent>,
    public azioneBPService: AzioneEBuonaPraticaService,
    private readonly utilityService: UtilityService,
    private readonly settoriService: SettoriService,
    private readonly sintesiService: SintesiService,
    private readonly bilancioService: BilancioService,
    private readonly policyService: PolicyService,
    private readonly pianoService: PianoService,
    private readonly stdrService: StandardRendicontazioneService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      azioneBP: AzioneBP;
      idContest: string;
      idAmbito: string;
      idTematica: string;
      contesto: string;
      idObiettivo: string;
    },
  ) {}

  get isConfigurazione() {
    return !this.data.contesto;
  }

  get idAzione() {
    return this.formAzioneBP.get('id')?.value ?? this.data?.azioneBP?.id ?? '';
  }

  ngAfterViewInit(): void {
    this._getSettori();
    if (this.data?.azioneBP) {
      Object.keys(this.data.azioneBP).forEach((key) => {
        this.formAzioneBP.get(key)?.setValue((this.data.azioneBP as any)[key]);
      });
      const idSettori = this.formAzioneBP.get('settori')?.value?.map((set) => set.id) || [];
      this.getStdrBySettore(idSettori);
    } else {
      this.getStdrBySettore([]);
    }
    this.cdRef.detectChanges(); // Forza il rilevamento delle modifiche
    /* this.getStdr(); */

    if (this.data.contesto && this.data?.azioneBP?.id && !this.data?.azioneBP?.creatoDaContesto) {
      this.formAzioneBP.get('descrizione')?.disable();
    }
  }

  onChangeSettore(event: MatSelectChange) {
    const idSettoriSelezionati: string[] = event.value.map((settore: Settore) => settore.id);

    this.getStdrBySettore(idSettoriSelezionati);
  }

  /**
   *  Get stdr by settore selezionato
   * @param settoriIds
   */
  private getStdrBySettore(settoriIds: string[]) {
    const idAzione = this.data?.azioneBP?.id ? this.data?.azioneBP?.id : null;
    const isCreazione = !idAzione;

    this.spinnerOver.show();
    this.azioneBPService
      .getStdrBySettore(idAzione, settoriIds, isCreazione)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito: STDR[]) => {
          this.objStdrOriginale = esito;

          this.compliance.setValue(this.stdrService.setOggettoSelectionCompliance(esito));

          this.stdr.setValue(this.stdrService.setOggettoSelectionStdr(esito));
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  /**
   * Funzione di salvataggio di un nuovo AzioneBP
   * @returns
   */
  compareSettori(settore1: Settore, settore2: Settore): boolean {
    return settore1.id === settore2.id; // Sostituisci "id" con la proprietà univoca degli AzioneBP
  }

  /**
   * Metodo salvataggio chiamato da HTML
   */
  async salvaInHtml() {
    this.closeDialog.set(true);
    await this.salva();
    if (this.closeDialog()) this.dialogRef.close();
  }

  /**
   * Esegue il processo completo di salvataggio dell'AzioneBP.
   *
   * Il metodo:
   * - valida il form
   * - effettua il merge dei dati STDR e compliance
   * - costruisce l'oggetto di salvataggio
   * - salva in contesto (sintesi, bilancio, policy, piano) oppure tramite il servizio standard
   * - mostra snackbar o dialog di errore
   * - gestisce lo spinner e ritorna un boolean con l'esito
   *
   */
  private async salva(): Promise<boolean> {
    if (!this.formAzioneBP.valid) {
      this.markFormControlsAsTouched();
      return false;
    }

    try {
      const stdrMerged = await this.mergeStdr(this.stdr.getRawValue(), false);
      const complianceMerged = await this.mergeStdr(this.compliance.getRawValue(), true);

      const objSalvataggio = this.buildPayload(stdrMerged, complianceMerged);

      if (this.data.idContest) {
        delete objSalvataggio.infoConsigliatoObbl;
        await this.salvaInContesto(objSalvataggio);
        return true;
      }

      this.spinnerOver.show();

      if (this.idAzione) {
        await this.updateAzioneBP(this.idAzione, objSalvataggio);
      } else {
        await this.createAzioneBP(objSalvataggio);
      }

      this.utilityService.openSnackBar('Salvataggio effettuato', '', {
        duration: 2000,
        panelClass: ['success-snackbar'],
      });
      return true;
    } catch (err) {
      console.error("Errore durante il salvataggio dell'AzioneBP:", err);
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: "Errore nel salvataggio dell'AzioneBP",
        bottoni: [{ nome_btn: 'Chiudi' }],
      });
      this.closeDialog.set(false);
      return false;
    } finally {
      this.spinnerOver.hide();
    }
  }

  /**
   * Imposta tutti i controlli del form come "touched".
   *
   * Utilizzato quando il form non è valido, per forzare la visualizzazione
   * degli errori di validazione nei campi.
   */
  private markFormControlsAsTouched(): void {
    Object.values(this.formAzioneBP.controls).forEach((control) => control.markAsTouched());
    this.closeDialog.set(false);
  }

  /**
   * Esegue il merge dei dati STDR o compliance tramite il servizio dedicato
   * e filtra i risultati in base al flag `isCompliance`.
   *
   * @param rawValue - Il valore del form per stdr o compliance.
   * @param isCompliance - Specifica se filtrare i risultati come compliance (true) o stdr (false).
   */
  private async mergeStdr(rawValue: any, isCompliance: boolean): Promise<any[]> {
    const mergedResult = await firstValueFrom(
      this.stdrService.mergeSelectedStdr(rawValue, this.objStdrOriginale),
    );
    return mergedResult.filter((padre) => padre.compliance === isCompliance);
  }

  /**
   * Costruisce l'oggetto finale da inviare ai servizi di salvataggio
   * unendo:
   *  - dati del contesto (se presenti)
   *  - valori del form
   *  - stdr e compliance mergeati
   *
   * @param stdrMerged - Array di elementi STD(R) mergeati.
   * @param complianceMerged - Array di elementi compliance mergeati.
   *
   * @returns {any} L'oggetto completo per la chiamata alla API.
   */
  private buildPayload(stdrMerged: any[], complianceMerged: any[]): any {
    return {
      ...(this.data.idContest ? this.data.azioneBP : {}),
      ...this.formAzioneBP.getRawValue(),
      compliance: complianceMerged,
      stdr: stdrMerged,
    };
  }

  /**
   * Effettua la chiamata API per aggiornare una AzioneBP esistente.
   *
   * @param id - L'ID dell'AzioneBP da aggiornare.
   * @param obj - L'oggetto dati da inviare alla API.
   */
  private async updateAzioneBP(id: string, obj: any): Promise<void> {
    await firstValueFrom(this.azioneBPService.putAzioneBP(id, obj));
  }

  /**
   * Effettua la chiamata API per creare una nuova AzioneBP.
   *
   * @param obj - L'oggetto dati da inviare alla API.
   */
  private async createAzioneBP(obj: any): Promise<void> {
    const result = await firstValueFrom(this.azioneBPService.postAzioneBP(obj));
    if (result) {
      this.formAzioneBP.get('id')?.setValue(result.body);
    }
  }

  /**
   * GET di settori
   */
  private _getSettori() {
    this.spinnerOver.show();
    this.settoriService
      .getSettori(
        0,
        1000,
        '',
        [],
        [
          {
            chiave: 'titolo',
            sort: 'desc',
          },
        ],
      )
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (result: any) => {
          this.arraySettori = result?.content || [];
        },
        error: (err: any) => {
          console.error('Errore durante il caricamento dei settori:', err);

          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Errore nel recupero dei settori',
            bottoni: [{ nome_btn: 'Ok' }],
          });
        },
      });
  }

  /**
   * Metodo che mi salva una nuova azione e buona pratica effimera in bilancio/sintesi
   * @returns
   */
  private async salvaInContesto(objSalvataggio: any): Promise<void> {
    if (!this.data.idAmbito) {
      this.mostraMessaggio('Attenzione', 'Ambito non trovato o non riconosciuto');
      return;
    }

    if (!this.data.idTematica) {
      this.mostraMessaggio('Attenzione', 'Tematica non trovata o non riconosciuta');
      return;
    }

    if (!this.idAzione) {
      this.formAzioneBP.get('creatoDaContesto')?.setValue(true);
    }

    const serviceCall = this.getServiceCallForContesto(objSalvataggio);
    if (!serviceCall) return;

    try {
      this.spinnerOver.show();
      const result = await firstValueFrom(serviceCall);
      this.mostraMessaggioSnackbar('Salvataggio effettuato');
      this.closeDialog.set(false);
      this.dialogRef.close(result);
    } catch (err) {
      console.error("Errore durante il salvataggio dell'azione buona pratica:", err);
      this.mostraMessaggio('Attenzione', "Errore nel salvataggio dell'azione buona pratica");
    } finally {
      this.spinnerOver.hide();
    }
  }

  /**
   * Mi prendo il servizio corretto da chiamare in base al contesto in cui sono
   * @param objSalvataggio oggetto da salvare da passare come parametro agli EP
   * @returns
   */
  private getServiceCallForContesto(objSalvataggio: any) {
    switch (this.data.contesto) {
      case 'sintesi':
        return this.sintesiService.putAzioneBPEffimeri(
          this.data.idContest,
          this.data.idAmbito,
          this.data.idTematica,
          objSalvataggio,
        );
      case 'bilancio':
        return this.bilancioService.putAzioniBPEffimeri(
          this.data.idContest,
          this.data.idAmbito,
          this.data.idTematica,
          objSalvataggio,
        );
      case 'policy':
        return this.policyService.putAzioniBPEffimeri(
          this.data.idContest,
          this.data.idAmbito,
          this.data.idTematica,
          objSalvataggio,
        );
      case 'piano':
        return this.pianoService.putTargetQualitativiEffimeri(
          this.data.idContest,
          this.data.idAmbito,
          this.data.idTematica,
          this.data.idObiettivo,
          objSalvataggio,
        );
      default:
        console.warn('Contesto non riconosciuto:', this.data.contesto);
        return null;
    }
  }

  /**
   * Mostro dialog
   * @param titolo
   * @param descrizione
   */
  private mostraMessaggio(titolo: string, descrizione: string) {
    this.utilityService.openDialog({
      titolo: titolo,
      descrizione: descrizione,
      bottoni: [{ nome_btn: 'Chiudi' }],
    });
  }

  /**
   * Mostro snackbar
   * @param titolo
   * @param descrizione
   */
  private mostraMessaggioSnackbar(messaggio: string) {
    this.utilityService.openSnackBar(messaggio, '', {
      duration: 2000,
      panelClass: ['success-snackbar'],
    });
  }

  mostraNoteFn() {
    this.mostraNote = !this.mostraNote;
  }

  /**
   * Metodo chiamato da html per la dialog prompt ai
   * prima salvo l'oggetto e poi apri la dialog
   */
  async ctrOpenPromptAI() {
    this.closeDialog.set(false);

    if (!this.idAzione) {
      await this.salva();
    }
    if (this.idAzione) {
      this.promptAI();
    }
  }

  /**
   * Dialog per inserimneto prompt
   */
  private promptAI() {
    const tipoElemento: TipoElemento = 'AZIONE';
    const dialogPromptAi = this.dialog.open(DialogPromptAiComponent, {
      data: {
        tipoElemento,
        idElemento: this.idAzione,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogPromptAi.afterClosed().subscribe((result) => {
      //
    });
  }
}
